import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../../custom/BackButton';
import ActionIcon from '../../custom/ActionIcon';
import { createdUpdatedInfo, formatMawb } from '../../../utils';
import { IRack } from '../../../globals/interfaces';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    rackItem: IRack | undefined;
}

export default function ModalViewDeleted ({
    modal,
    setModal,
    rackItem
}: Props) {

    const toggle = () => setModal(!modal);

    if (!rackItem) return null;

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>MAWB {formatMawb(rackItem.s_mawb)} | HAWB {rackItem.s_hawb} | Location {rackItem.s_location}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h6>Deleted Reason/Notes: {rackItem.s_notes}</h6>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo(rackItem)}
                    </Label>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;